import styled from '@emotion/styled';
import { Flex } from 'roo-ui/components';

const noPrint = () => ({ '@media print': { display: 'none' } });
export const PropertySummaryMain = styled(Flex)();
PropertySummaryMain.defaultProps = {
  flex: '1 1 auto',
  flexDirection: 'column',
  overflow: 'hidden',
  mr: [0, 0, 6],
  pb: [4, 0, 0],
  mb: [6, 8, 0],
  borderBottom: [1, 0, 0],
  borderColor: 'greys.alto',
};

export const PropertySummaryAside = styled(Flex)(noPrint);
PropertySummaryAside.defaultProps = {
  flex: ['1 0 auto', '1 0 auto', '0 0 400px'],
  flexDirection: ['column', 'row', 'column'],
  justifyContent: ['flex-start', 'space-between', 'flex-start'],
  mx: [3, 0],
};
